/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  Save,
  HelpCircle,
  Home,
  Users,
  FileText,
  ToggleRight,
} from "lucide-react";
import apicache from "../../components/clearCach/clear";
import { useTranslation } from "react-i18next";

function FooterSettings() {
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const MySwal = withReactContent(Swal);
  const [showSideBar, setShowSideBar] = useState(true);
  const products = useSelector((state) => state.ProductsReducer);
  const [data, setData] = useStoreFormDraft(store);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const message = (e) => {
    e.preventDefault();
    MySwal.fire({
      title: (
        <a href="https://m.me/F0orweb" target="_blank" rel="noreferrer">
          {t("footerSettings.swal_contact_link")}
        </a>
      ),
      isDismissed: true,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    apicache(account, products);
    try {
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      Swal.fire({
        icon: "success",
        title: t("footerSettings.swal_success_title"),
        confirmButtonText: t("footerSettings.swal_success_confirm"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } catch (error) {
      Swal.fire({ icon: "error", title: t("ui.notSaved"), confirmButtonText: t("ship.ok") });
    }
  };

  return (
    <div className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 w-full dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d] flex flex-col gap-y-6">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-0">
                  {t("footerSettings.page_title")}
                </h2>
                <p className="text-gray-600 dark:text-gray-400 mb-0">
                  {t("footerSettings.page_subtitle")}
                </p>
              </div>
            </div>
          </div>

          {/* Main Content */}
          {data && (
            <form onSubmit={!!account.store ? handleSubmit : message}>
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="mb-6">
                  <div className="bg-[#fcf6ff] dark:!bg-[#1f1f1f] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-5">
                    <div className="flex items-start gap-3">
                      <div className="p-2 bg-[#faf1ff] dark:!bg-[#292929] rounded-full text-[#9e68ba]">
                        <HelpCircle size={20} />
                      </div>
                      <div>
                        <h3 className="text-[#9e68ba] font-semibold mb-1">
                          {t("footerSettings.instruction_title")}
                        </h3>
                        <p className="text-[#9e68ba] text-sm">
                          {t("footerSettings.instruction_text")}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-4">
                    {/* Master Toggle */}
                    <div className="bg-white dark:!bg-[#181819] rounded-lg p-4 border border-gray-200 dark:!border-[#3c3a3d] hover:border-purple-200 transition-colors">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <ToggleRight size={20} className="text-[#9e68ba]" />
                          <div>
                            <label className="block text-gray-700 dark:text-gray-200 font-medium">
                              {t("footerSettings.footer_title_label")}
                            </label>
                            <p className="text-gray-500 dark:text-gray-400 text-sm">
                              {t("footerSettings.footer_title_description")}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center">
                          <label className="inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="sr-only peer "
                              checked={data.activatefooterlink}
                              onChange={() =>
                                setData({
                                  ...data,
                                  activatefooterlink: !data.activatefooterlink,
                                })
                              }
                            />
                            <div className="relative w-11 h-6 bg-gray-200 dark:!bg-[#3c3a3d] rounded-full peer peer-focus:ring-4 peer-focus:ring-purple-300 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#9b59bf]"></div>
                          </label>
                        </div>
                      </div>
                      <div className="mt-3">
                        <input
                          type="text"
                          placeholder={t("footerSettings.footer_title_placeholder")}
                          value={data.footername}
                          onChange={(e) =>
                            setData({ ...data, footername: e.target.value })
                          }
                          className="w-full pr-4 pl-4 py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent bg-white dark:!bg-[#181819] text-gray-700 dark:text-gray-200"
                        />
                      </div>
                    </div>

                    {/* Home Link */}
                    <div className="bg-white dark:!bg-[#181819] rounded-lg p-4 border border-gray-200 dark:!border-[#3c3a3d] hover:border-purple-200 transition-colors">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <Home size={20} className="text-[#9e68ba]" />
                          <div>
                            <label className="block text-gray-700 dark:text-gray-200 font-medium">
                              {t("footerSettings.home_link_label")}
                            </label>
                            <p className="text-gray-500 dark:text-gray-400 text-sm">
                              {t("footerSettings.home_link_description")}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center">
                          <label className="inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="sr-only peer"
                              checked={data.homelinkcheck}
                              onChange={() =>
                                setData({
                                  ...data,
                                  homelinkcheck: !data.homelinkcheck,
                                })
                              }
                            />
                            <div className="relative w-11 h-6 bg-gray-200 dark:!bg-[#3c3a3d] rounded-full peer peer-focus:ring-4 peer-focus:ring-purple-300 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#9b59bf]"></div>
                          </label>
                        </div>
                      </div>
                      <div className="mt-3">
                        <input
                          type="text"
                          placeholder={t("footerSettings.home_link_placeholder")}
                          value={data.homelink}
                          onChange={(e) =>
                            setData({ ...data, homelink: e.target.value })
                          }
                          className="w-full pr-4 pl-4 py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent bg-white dark:!bg-[#181819] text-gray-700 dark:text-gray-200"
                        />
                      </div>
                    </div>

                    {/* About Us Link */}
                    <div className="bg-white dark:!bg-[#181819] rounded-lg p-4 border border-gray-200 dark:!border-[#3c3a3d] hover:border-purple-200 transition-colors">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <Users size={20} className="text-[#9e68ba]" />
                          <div>
                            <label className="block text-gray-700 dark:text-gray-200 font-medium">
                              {t("footerSettings.about_us_label")}
                            </label>
                            <p className="text-gray-500 dark:text-gray-400 text-sm">
                              {t("footerSettings.about_us_description")}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center">
                          <label className="inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="sr-only peer"
                              checked={data.aboutuslinkcheck}
                              onChange={() =>
                                setData({
                                  ...data,
                                  aboutuslinkcheck: !data.aboutuslinkcheck,
                                })
                              }
                            />
                            <div className="relative w-11 h-6 bg-gray-200 dark:!bg-[#3c3a3d] rounded-full peer peer-focus:ring-4 peer-focus:ring-purple-300 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#9b59bf]"></div>
                          </label>
                        </div>
                      </div>
                      <div className="mt-3">
                        <input
                          type="text"
                          placeholder={t("footerSettings.about_us_placeholder")}
                          value={data.aboutuslink}
                          onChange={(e) =>
                            setData({ ...data, aboutuslink: e.target.value })
                          }
                          className="w-full pr-4 pl-4 py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent bg-white dark:!bg-[#181819] text-gray-700 dark:text-gray-200"
                        />
                      </div>
                    </div>

                    {/* Privacy Policy Link */}
                    <div className="bg-white dark:!bg-[#181819] rounded-lg p-4 border border-gray-200 dark:!border-[#3c3a3d] hover:border-purple-200 transition-colors">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <FileText size={20} className="text-[#9e68ba]" />
                          <div>
                            <label className="block text-gray-700 dark:text-gray-200 font-medium">
                              {t("footerSettings.privacy_policy_label")}
                            </label>
                            <p className="text-gray-500 dark:text-gray-400 text-sm">
                              {t("footerSettings.privacy_policy_description")}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center">
                          <label className="inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="sr-only peer"
                              checked={data.policylinkckeck}
                              onChange={() =>
                                setData({
                                  ...data,
                                  policylinkckeck: !data.policylinkckeck,
                                })
                              }
                            />
                            <div className="relative w-11 h-6 bg-gray-200 dark:!bg-[#3c3a3d] rounded-full peer peer-focus:ring-4 peer-focus:ring-purple-300 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#9b59bf]"></div>
                          </label>
                        </div>
                      </div>
                      <div className="mt-3">
                        <input
                          type="text"
                          placeholder={t("footerSettings.privacy_policy_placeholder")}
                          value={data.policylink}
                          onChange={(e) =>
                            setData({ ...data, policylink: e.target.value })
                          }
                          className="w-full pr-4 pl-4 py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent bg-white dark:!bg-[#181819] text-gray-700 dark:text-gray-200"
                        />
                      </div>
                    </div>

                  </div>
                </div>

                {/* Save Button */}
                <div className="flex justify-center mt-6">
                  <button
                    type="submit"
                    className="py-2 px-6 rounded-lg bg-[#9b59bf] hover:bg-[#814a9f] text-white font-medium flex items-center gap-2 transition-colors shadow-sm"
                  >
                    <Save size={18} />
                    {t("footerSettings.submit_button")}
                  </button>
                </div>
              </div>
            </form>
          )}

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default FooterSettings;
